export const progressbarTheme = {
  root: {
    borderRadius: '{content.border.radius}'
  },
  value: {
    background: '{primary.500}'
  },
  label: {
    fontSize: '0.75rem',
    fontWeight: '600'
  },
  colorScheme: {
    light: {
      root: {
        height: '8px',
        background: '{surface.200}'
      },
      label: {
        color: '{surface.0}'
      }
    },
    dark: {
      root: {
        height: '8px',
        background: '{surface.100}'
      },
      label: {
        color: '{surface.0}'
      }
    }
  }
};
